import { FC } from "react";
import { Route, Routes } from "react-router-dom";
import { LogoutPage } from "./LogoutPage";

const Router: FC = () => {
  return (
    <Routes>
      <Route index element={<LogoutPage />} />
    </Routes>
  );
};
export default Router;
